/**
 * Initialize a 3Q Video Player in a Container
 * @param {HTMLElement} videoContainer
 * @returns {js3q | undefined}
 */
const init3QVideo = (videoContainer) => {
    if(videoContainer.dataset.isInitialized === 'true') {
        return;
    }
    const playoutId = videoContainer.dataset.playoutId;
    const containerId = `player-3q-${crypto.randomUUID()}`;
    videoContainer.id = containerId;
    videoContainer.dataset.isInitialized = 'true';
    videoContainer.player = new js3q({
        playoutId: playoutId,
        container: containerId,
    });
};

/**
 * Initialize all 3Q Video Players within this container
 * @param {HTMLElement} container
 */
const init3QVideosInContainer = (container) => {
    const videoContainerElements = container.querySelectorAll('.video-3q');
    for (const videoContainerElement of videoContainerElements) {
        init3QVideo(videoContainerElement);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    init3QVideosInContainer(document);
});

window.addEventListener('init3QPlayers', () => {
    init3QVideosInContainer(document);
});

document.addEventListener('pause3QPlayers', (ev) => {
    const videoContainerElements = ev.target?.querySelectorAll('.video-3q');
    if (videoContainerElements) {
        for (const videoContainerElement of videoContainerElements) {
            videoContainerElement.player?.pause();
        }
    }
});
